import { UmbracoTypes } from '~/lib/data-contract';
import { useModuleTheme } from '../../hooks/useModuleTheme';
import { ModuleContainer } from '../../shared/ModuleContainer';
import { StyledM110Tally } from './styled';
import { useEffect } from 'react';

type M110TallyProps = UmbracoTypes.IM110TallyModule;


export const M110Tally = ({ headline, tallyID, ...rest }: M110TallyProps) => {
    const { textColor } = useModuleTheme(rest);

    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://tally.so/widgets/embed.js';
        script.async = true;
        document.body.appendChild(script);
    }, []);

    return (
        <ModuleContainer hasGutter {...rest}>
            <StyledM110Tally textColor={textColor}>
                <iframe
                    data-tally-src={`https://tally.so/embed/${tallyID}?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1`}
                    width="100%"
                    title={headline || 'Tally Form'}
                />
            </StyledM110Tally>
        </ModuleContainer>
    );
};
